// extracted by mini-css-extract-plugin
export default {"buttonNew":"LHmgtgSDX7qckhDefTzg","icon":"XM4BojU7tBVWUgRylKXH","pulse":"P_jeqOOBEpwQYrvuZsVZ"};